import { Stack, styled, Typography } from '@mui/material';

export const StyledTitleWrapper = styled(Stack)(({ theme }) => ({
  alignItems: 'center',
  justifyContent: 'center',
  marginBottom: theme.spacing(3),
  marginTop: theme.spacing(9),
}));

export const StyledInfoTypography = styled(Typography)({
  fontSize: 24,
  fontWeight: 900,
  lineHeight: 1.5,
  letterSpacing: 'normal',
});
